import React from 'react';
import StudentForm from './StudentForm';
import EditStudent from '../../../../fuse-layouts/shared-components/student-form/EditStudent';
import AddEditContact from '../../../../fuse-layouts/shared-components/student-form/AddEditContact';
import ExpiredLink from './ExpiredLink';
import EditMedications from '../../../../fuse-layouts/shared-components/student-form/EditMedications';

const StudentFormConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false,
				},
				footer: {
					display: false,
				},
			},
		},
	},
	routes: [
		{
			path: '/studentform',
			element: (
				<React.Suspense fallback={<>...</>}>
					<StudentForm />
				</React.Suspense>
			),
		},
		{
			path: '/studentformedit',
			element: (
				<React.Suspense fallback={<>...</>}>
					<EditStudent />
				</React.Suspense>
			),
		},
		{
			path: '/studentcontact',
			element: (
				<React.Suspense fallback={<>...</>}>
					<AddEditContact />
				</React.Suspense>
			),
		},
		{
			path: '/expiredlink',
			element: (
				<React.Suspense fallback={<>...</>}>
					<ExpiredLink />
				</React.Suspense>
			),
		},
		{
			path: '/medications',
			element: (
				<React.Suspense fallback={<>...</>}>
					<EditMedications />
				</React.Suspense>
			),
		},
	],
};

export default StudentFormConfig;
